import React, { useState, useEffect } from 'react';
import ScoreIcon from "assets/images/images_new/pie-chart-icon.svg";
import RecordedWaveform from "components/Question/Speaking/RecordedWaveform";
import Content from "/public/images/popup-icons/Content.png";
import linguistic from "/public/images/popup-icons/linguistic-icon.png";
import Structure from "/public/images/popup-icons/structure-icon.png";
import Pronunciation from "/public/images/popup-icons/pronoun.png";
import Fluency from "/public/images/popup-icons/checkboxGreen.png";
import BarFrequency from "/public/images/popup-icons/popupBar.png";
import Grammar from "/public/images/popup-icons/Grammar.png";
import Vocabulary from "/public/images/popup-icons/Vocabulary.png";
import FormIcon from "/public/images/popup-icons/Form.png";
import { Tooltip } from 'react-bootstrap';

export default function WritingResult(props) {
	const [result, setResult] = useState(null);
	const [buttons, setButtons] = useState(false);
	const [isEssay, setIsEssay] = useState(false);
	const NOT_ALLOWED = ['overall'];

	const ICON_MAP = {
		content: Content,
		fluency: Fluency,
		pronunciation: Pronunciation,
		overall: BarFrequency,
		grammar: Grammar,
		grammer: Grammar,
		form: FormIcon,
		vocabulary: Vocabulary,
		linguistic: linguistic,
		structure: Structure,
		spelling: Vocabulary
	};

	const getIconByType = (type) => {
		return ICON_MAP[type?.toLowerCase()] || "";
	};	
	
	const validKeys = [
		"content",
		"form",
		"grammar", // Write Essay Only.
		"grammer", // Summarize Written Text only.
		"vocabulary",
		"linguistic",
		"structure",
		"spelling"
	];

	useEffect(() => {
		const { resultData, buttonsOnly, essay } = props;
		
		setResult(resultData);
		setButtons(buttonsOnly);
		setIsEssay(essay);
	}, []);


	const errorMessage = () => {
		if (result.content.score === 0 && result?.feedback?.content) {
			return (
				<div className="gab-card result-content mb-3 reading-text">
					<div className="error-message alert-danger">
						{result?.feedback?.content}
					</div>
				</div>
			);
		} else if (result.form.score === 0 && result?.feedback?.form) {
			return (
				<div className="gab-card result-content mb-3 reading-text">
					<div className="error-message alert-danger">
						{result?.feedback?.form}
					</div>
				</div>
			);
		}
	}

	const scoreClass = (score) => {
		let class_name = "color-danger";

		if (score > 30 && score <= 60) {
			class_name = "color-warning";
		} else if (score > 60) {
			class_name = "color-success";
		}

		return class_name;
	}
	const score = props.subcategoryId !== 5 
	? result?.overall?.score 
	: result?.content?.score;

	const outOf = props.subcategoryId !== 5 
	? result?.overall?.out_of 
	: result?.content?.out_of;

	const percent = outOf ? (score / outOf) * 100 : 0;

	return (
		<>
			{(result !== null && props.showMainContent) &&
				<>
					<div className='d-none'>
						<div className='score-content'>
							
						</div>
					</div>
					<div className='card popup-border p-4 mb-4' >
						<div className="row align-items-center">

						{/* LEFT */}
						<div className="col-12 text-center text-lg-start mb-4 mb-lg-0">

							<div className="d-flex flex-column flex-sm-row align-items-center gap-3 gap-sm-4 mb-3">
							{/* <div className="score-circle-modern">
								{props.subcategoryId !== 5
								?  `${result?.overall?.score}/${result?.overall?.out_of}`
								: `${result?.content?.score}/${result?.content?.out_of}`}
							</div> */}
							 <div className="score-circle-modern" style={{ "--progress": `${percent}%` }}>
								{/* {props.subcategoryId !== 5
								? `${result?.overall?.score}/${result?.overall?.out_of}`
								: `${result?.content?.score}/${result?.content?.out_of}`} */}
								<span>{score}/{outOf}</span>
							</div>

							<h6 className="result-score mb-0">Overall Score</h6>
							</div>
						</div>

						{/* RIGHT */}
						<div className="col-12">
						<div className="row g-3">

							{Object.keys(result).map((item, i) => {
							if (validKeys.includes(item)) {
								return (
								<div key={i} className="col-12 col-md-6">

									<div className="score-card-item d-flex justify-content-between align-items-center h-100 p-3 list-score-detail-border">

									<div className="d-flex align-items-center gap-2">
										<img
										src={getIconByType(item)}
										alt={result[item]?.label}
										className="img-fluid"
										style={{ width: "28px" }}
										/>
										<span className="label-text">
										{result[item]?.label}
										</span>
									</div>

									<strong className="label-score">
										{result[item]?.score}/{result[item]?.out_of}
									</strong>

									</div>

								</div>
								);
							}
							return null;
							})}

						</div>
						</div>

						</div>
					</div>

					
					{/* Show error message only. If any. Only Essay */}
					{isEssay && errorMessage()}


					<div className='gab-card result-content mb-3'>
						<div className='gab-text size-adjust mt-0'>
							{props.newHtml !== null &&
								<>
									{props.renderResponseHtml(props.newHtml)}
								</>
							}

							{props.newResult !== null && props.newResult !== undefined && 'html' in props.newResult &&
								props.renderResponseHtmlOldStyle(props.newResult.html)
							}
						</div>

						{props.subcategoryId === 7 &&
						<div className='result-view-remarks clearfix'>
								<>
									<div className="result-popup-btn m-0 p-0 pmw-outer-wrapper pull-left">
										<div className="left-btns">
											<button type="button" className="outline-btn hoverDisable">Total Score: {result.overall.score}</button>
										</div>
									</div>

									<div className="result-popup-btn m-0 p-0 pmw-outer-wrapper pull-left mx-2">
										<div className="left-btns ml-2">
											<button type="button" className="outline-btn hoverDisable" id="english-pattern-btn">{result.english_pattern} English
												<span className="info-icon-wrapper" id="english-pattern-info">
													<i className="bi bi-info-circle-fill info-icon"></i>
													<span className="custom-tooltip">
													Evaluation based on UK English.

													</span>
												</span>
											</button>
											
										</div>
									</div>

									<div className="result-popup-btn m-0 p-0 pmw-outer-wrapper pull-left">
										<div className="left-btns ml-2">
											<button type="button" className="outline-btn hoverDisable">Word Count: {result.word_count}</button>
										</div>
									</div>
								</>
						</div>
						}
					</div>

				</>
			}
				<div className="pull-left">
					{props.moreDetails}
				</div>
					{props.aiSuggestions}
		</>
	);
}